import React from "react";
import { Link } from "react-router-dom";
const UnauthorizedPage = () => {
  return (
    <>
      <div className="content">
        <div className="container">
          <div
            className="error-main-logo text-center"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img src="assets/img/logo-dark.svg" alt="Img" />
          </div>
          <div className="error-img text-center">
            <img src="assets/img/error-401.svg" alt="Img" />
          </div>
          <div className="maintenance-update">
            <div className="text-center mb-3">
              <h5 className="mb-1">401 Oops! Truy cập không được phép</h5>
              <p className="text-gray-6">
                Bạn không có quyền truy cập vào trang này. Vui lòng đăng nhập
                hoặc kiểm tra quyền hạn của bạn.
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <Link
                to="/login"
                className="btn btn-primary d-flex align-items-center justify-content-center"
              >
                <i className="isax isax-arrow-left-2 me-2"></i>Đăng nhập
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnauthorizedPage;
